import {Hub, systemStickers} from 'yougile-model'
import {OptionsItemCheckbox} from '@components/common/base/dropdown-button-menu/types'
import {Sticker} from '@extensions/sticker/sticker'

export const getUnpinInitStickers = (
  board: Hub,
  editHub?: Hub
): OptionsItemCheckbox[] => {
  editHub
  if (editHub) {
    const selectedIds = editHub.data.movementTemplate.unpinStickers

    const options = getStickersOptions(board, true)
    for (const option of options) {
      if (selectedIds.includes(option.id)) {
        option.selected = true
      } else {
        option.selected = false
      }
    }

    return options
  }

  return getStickersOptions(board, true)
}

const getStickersOptions = (
  board: Hub,
  selected = false
): OptionsItemCheckbox[] => {
  if (!board) {
    return []
  }

  let stickers = Sticker.list(board)
  const exclude = [systemStickers.User, systemStickers.Repeat]
  stickers = stickers.filter(s => !exclude.includes(s.id))

  const options: OptionsItemCheckbox[] = stickers.map(sticker => {
    return {
      id: sticker.id,
      text: Sticker.getName(sticker),
      selected
    }
  })

  return options
}
